import { z } from "zod";

/**
 * Get Deployment Path Variables Schema
 */
export const GetDeploymentPathVarsSchema = z.object({
  id: z.string().uuid()
});

export type GetDeploymentPathVars = z.infer<typeof GetDeploymentPathVarsSchema>;
